import React from "react";
import "./GlassCard.css";

export default function GlassCardForButtons({ children, variant = "", isLarge = false }) {
  // Compute context-based styling classes
  const containerClassName = `glass-container-for-buttons ${
    isLarge ? "glass-container-for-buttons---large" : "glass-container-for-buttons--small"
  }`.trim();
  const contentClassName = `glass-content-for-buttons ${
    variant === "inline" ? "glass-content-for-buttons--inline" : ""
  }`.trim();

  return (
    <div className={containerClassName}>
      <div className="glass-filter-for-buttons" />
      <div className="glass-overlay-for-buttons" />
      <div className="glass-specular-for-buttons" />
      <div className={contentClassName}>{children}</div>
    </div>
  );
}
